const TIER_LABEL: Record<string, string> = { free: 'Free', tier_1: 'Starter', tier_2: 'Growth', tier_3: 'Scale' };

interface Props {
  domainId: string;
  email: string;
  tier: string;
  onBillingPortal: () => void;
}

export function AfiSettingsPage({ email, tier, onBillingPortal }: Props) {
  return (
    <div className="min-h-screen bg-[#F1F5F9] p-8">
      <div className="mb-8">
        <p className="text-[11px] font-semibold tracking-[0.16em] uppercase text-[#1D9E75] mb-1">
          Auto-fix
        </p>
        <h1 className="text-2xl font-semibold text-[#0F172A]">AFI settings</h1>
        <p className="text-sm text-[#475569] mt-1">
          Account and billing settings for the Auto-fix Intelligence suite.
        </p>
      </div>

      <div className="max-w-xl space-y-4">
        {/* Account info */}
        <div className="bg-white rounded-[6px] p-6">
          <p className="text-[11px] font-semibold tracking-[0.16em] uppercase text-[#94A3B8] mb-4">
            Account
          </p>
          <div className="grid grid-cols-2 gap-y-3 text-sm">
            <span className="text-[#475569]">Email</span>
            <span className="text-[#0F172A] font-medium">{email}</span>
            <span className="text-[#475569]">Plan</span>
            <span className="text-[#0F172A] font-medium">{TIER_LABEL[tier] ?? tier}</span>
          </div>
        </div>

        {/* Billing */}
        <div className="bg-white rounded-[6px] p-6">
          <p className="text-[11px] font-semibold tracking-[0.16em] uppercase text-[#94A3B8] mb-3">
            Billing
          </p>
          <p className="text-sm text-[#475569] mb-4">
            Manage your subscription, update payment details, or download invoices.
          </p>
          <button
            onClick={onBillingPortal}
            className="bg-[#0F172A] text-white text-sm font-medium px-5 py-2.5 rounded-[6px] hover:bg-[#0F6E56] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1D9E75]"
          >
            Open billing portal
          </button>
        </div>

        {/* AFI feature info */}
        <div className="bg-white rounded-[6px] p-6">
          <p className="text-[11px] font-semibold tracking-[0.16em] uppercase text-[#94A3B8] mb-3">
            Auto-fix Intelligence
          </p>
          <p className="text-sm text-[#475569]">
            AFI automatically generates and deploys schema markup, meta tags, header fixes, and
            citation submissions based on your audit results. All fixes are reviewed here before
            being dispatched to your site.
          </p>
          {tier === 'free' && (
            <div className="mt-4 p-3 bg-[#F1F5F9] border border-[#E2E8F0] rounded-[6px]">
              <p className="text-xs text-[#475569]">
                AFI is available on Starter and above. Upgrade your plan to enable automatic fix
                generation.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
